import compose from 'recompose/compose';
import React from 'react';
import { string, number, shape } from 'prop-types';
import sizeMe from 'react-sizeme';
import { withStyles } from 'material-ui/styles';

import Scene from '../../common/Scene';
import Stackup from '../../common/Stackup';
import { FOIL } from '../../../constants/globals';
import { buildLayers } from '../../../lib/stackup'
import {
  materialPropType,
  materialWithCountPropType
} from '../../../lib/shapes';

const styles = () =>({
  root: {
    height: '100%',
    minHeight: '100%',
    boxSizing: 'border-box',
  },
});

export const StackupPreview  = ({
  classes,
  size,
  stackupType,
  numberOfCopperLayers,
  innerCopperWeight,
  outerCopperWeight,
  core,
  prepreg,
}) => {
  const width =  size.width - 10;
  const height = size.height - 10;
  const layers = buildLayers({
    stackupType,
    numberOfCopperLayers,
    innerCopperWeight,
    outerCopperWeight,
    core,
    prepreg,
  });

  return (
    <div className={classes.root}>
      <Scene animate autoRender={false} width={width} height={height}>
        <Stackup layers={layers} />
      </Scene>
    </div>
  );
}

StackupPreview.propTypes = {
  size: shape({
    width: number,
    height: number
  }).isRequired,
  classes: shape({
    root: string
  }).isRequired,
  stackupType: string,
  numberOfCopperLayers: number,
  innerCopperWeight:    number,
  outerCopperWeight:    number,
  core: shape(materialPropType),
  prepreg: shape(materialWithCountPropType),
};

StackupPreview.defaultProps = {
  stackupType:          FOIL,
  numberOfCopperLayers: 4,
  innerCopperWeight:    0.5,
  outerCopperWeight:    0.5,
  core: undefined,
  prepreg: undefined
}

export default compose(
  sizeMe({ monitorHeight: true, monitorPosition: true}),
  withStyles(styles)
)(StackupPreview);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/StartNew/StackupPreview.js